import { CurrencyCode } from 'shared'
import { t } from './i18n'

export const formatAmount = (num: number): string => {
  const sign = num < 0 ? '-' : ''
  const thousandSep: string = t('thousand_sep')
  const value: string =
    sign +
    String(Math.abs(Math.round(num)))
      .split('')
      .reverse()
      .reduce((memo: string[], char: string, idx: number): string[] => {
        if (idx > 0 && idx % 3 === 0) {
          memo.unshift(thousandSep)
        }
        memo.unshift(char)
        return memo
      }, [])
      .join('')

  return value
}

export const formatCurrency = (
  amount: number,
  currencyCode: CurrencyCode = 'DKK',
  noSymbol: boolean = false
): string => {
  const sign = amount < 0 ? '-' : ''
  const fam = formatAmount(Math.abs(amount))
  if (noSymbol) {
    switch (currencyCode) {
      case 'DKK':
        return `${sign}${fam} ${currencyCode}-,`
      case 'EUR':
        return `${sign}€${fam},-`
      default:
        return `${sign}${fam} ${currencyCode}-,`
    }
  }
  switch (currencyCode) {
    case 'EUR':
      return `${sign}€${fam}`
    default:
      return `${sign}${fam} ${currencyCode}`
  }
}

export const formatCurrencyAlwaysSign = (
  amount: number,
  currencyCode: CurrencyCode = 'DKK'
): string => {
  const prefix = amount > 0 ? '+' : ''
  return prefix + formatCurrency(amount, currencyCode)
}
